import PropTypes from 'prop-types';
import React, { Suspense, lazy, useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { pageUrls } from 'globalconfig/constants/keys';
import { AuthProvider } from 'globalservices/auth';
import { getAuthDetails, isValidObject } from 'globalutils/fmUtils';
import RenderComponent from './RenderComponent';
import useAuthGuard from './useAuthGuard';
import CautionIcon from 'globalcomponents/CautionIcon'

const layout = window?.$environment?.CURRENT_LAYOUT;
const Modal = lazy(() => import(`globalcomponents/UI/Modal/${layout}`));
const Department = lazy(() => import(`globalmodules/Department/Wrapper`));

const Routes = ({ history, location, folderPath, handleLogin }) => {
  const [auth, setAuth] = useState(getAuthDetails());
  const [resetPopupOpen, setResetPopupOpen] = React.useState(false);

  useEffect(() => {
    const cookie = getAuthDetails();
    const isNotValidCookie = !isValidObject(cookie);
    const isNotAuthenticated = !auth?.auth;
    if (isNotAuthenticated || isNotValidCookie) {
      setAuth(cookie);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location.state, auth]);

  const basePath = `.${folderPath}${window?.$environment?.SERVICE_PROVIDER}`;
  const getConfig = (file) => {
    try {
      const config = require(`${basePath}/${file}`).default;
      return config;
    } catch (error) {
      return [];
    }
  };

  const publicConfig = getConfig('publicConfig');

  useEffect(() => {
    const isAuthenticated = auth?.auth;
    const currentPath = window.location.pathname;

    if (isAuthenticated && currentPath === pageUrls.resetPassword) {
      setResetPopupOpen(true);
    } else {
      setResetPopupOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history.location]);

  const publicRoutes = publicConfig.map((config, key) => {
    return (
      <Route
        exact
        path={config.url}
        render={() => {
          const ifLayouPlain = config?.layout === 'plain';
          const AsyncComponent =
            (ifLayouPlain &&
              lazy(() => {
                return import(`../pages${folderPath}${config.component}`);
              })) ||
            null;
          const isComponent = isValidObject(AsyncComponent);
          return isComponent ? (
            <Suspense fallback={null}>
              <AsyncComponent history={history} pageTitle={config.title} />
            </Suspense>
          ) : (
            <RenderComponent history={history} setAuth={setAuth} config={config} folderPath={folderPath} />
          );
        }}
        key={key}
      />
    );
  });

  const { privateRotes, filterPopupOpen, setFilterPopupOpen } = useAuthGuard({ history, location, folderPath, setAuth });

  return (
    <AuthProvider value={{ ...auth }}>
      <Switch>
        {publicRoutes}
        {privateRotes}
        <Route
          path={window.location.pathname}
          render={() => (
            <RenderComponent
              history={history}
              setAuth={setAuth}
              config={{ title: 'Page not found', component: 'Unhandled' }}
              setFilterPopup={setFilterPopupOpen}
              folderPath={folderPath}
              message=""
            />
          )}
        />
        <Redirect to={window.location.pathname} />
      </Switch>
      <Modal
        open={resetPopupOpen}
        setOpen={setResetPopupOpen}
        data={{
          header: '',
          content: () => (
            <>
              <CautionIcon />
            </>
          ),
        }}
        isresets
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
      />

      {filterPopupOpen && (
        <Modal
          open={filterPopupOpen}
          setOpen={setFilterPopupOpen}
          data={{
            header: '',
            content: () => <Department action={() => setFilterPopupOpen(false)} />,
          }}
          background="black"
          withCloseIcon
        />
      )}
    </AuthProvider>
  );
};
export default Routes;

Routes.defaultProps = {
  children: null,
};
Routes.propTypes = {
  location: PropTypes.object.isRequired,
  folderPath: PropTypes.string.isRequired,
  children: PropTypes.element,
  history: PropTypes.object.isRequired,
};
